import { render, staticRenderFns } from "./ProjectTags.vue?vue&type=template&id=4c6b6151&"
import script from "./ProjectTags.vue?vue&type=script&lang=js&"
export * from "./ProjectTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports